import React from 'react';
import { Switch } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { useTimezone } from 'hooks';
import './TimezoneNote.scss';


const getTimezoneName = (timezone) => {
  const parts = timezone.split('/');
  const city = parts.pop();
  const region = parts.length > 1 ? parts.pop().replace('_', ' ') : null;
  return `${city.replace('_', ' ')}${region ? ` (${region})` : ''}`;
};


const TimezoneNote = ({
  timezone,
}) => {
  const { t } = useTranslation();
  const {
    localTimezone,
    displayLocalTimezone,
    sameTimezone,
    setDisplayLocalTimezone,
  } = useTimezone(timezone);

  if (sameTimezone) {
    return null;
  }

  return (
    <div className="timezone-note container">
      <div className="timezone-note switch">
        <sup>*</sup>{t('heure-de-timezoneCity', { timezoneCity: getTimezoneName(timezone) })}
        <Switch
          size="small"
          checked={displayLocalTimezone}
          onChange={() => setDisplayLocalTimezone(!displayLocalTimezone)}
          color="default"
        />
        {t('heure-de-timezoneCity', { timezoneCity: getTimezoneName(localTimezone) })}
      </div>
    </div>
  );
};


export default TimezoneNote;
